import { useState } from "react";
import { toast } from "sonner";
import { savePassImage } from "./passImage";
import { photoSrc } from "./PassPhoto";
import { hasNativeInstallPrompt, isStandalone, triggerNativeInstall } from "./installPass";
import { InstallGuide } from "./InstallGuide";

// Boutons « Enregistrer dans mon téléphone » de la carte de membre.
export function PassActions({ data, qrCanvasId }) {
  const [guide, setGuide] = useState(false);
  const [busy, setBusy] = useState(false);
  const installed = isStandalone();

  const saveImage = async () => {
    setBusy(true);
    try {
      const r = await savePassImage({
        qrCanvas: document.getElementById(qrCanvasId),
        name: data.name, discipline: data.discipline, belt: data.belt, pin: data.pin, school: data.branding?.school,
        photoSrc: photoSrc(data.photo_url), emblemSrc: data.emblem_url,
      });
      if (r === "shared") toast.success("Carte partagée — choisis « Enregistrer l'image » pour la garder dans Photos.");
      else if (r === "downloaded") toast.success("Image de la carte téléchargée.");
    } catch { toast.error("Impossible de générer l'image."); }
    finally { setBusy(false); }
  };

  const addToHome = async () => {
    if (hasNativeInstallPrompt()) {
      const ok = await triggerNativeInstall();
      if (ok) { toast.success("Carte ajoutée à ton écran d'accueil 🎉"); return; }
    }
    setGuide(true);
  };

  return (
    <div className="w-full max-w-sm mt-5" data-testid="pass-actions">
      <div className="text-[11px] uppercase tracking-widest text-zinc-500 mb-2 text-center">📲 Enregistrer dans mon téléphone</div>
      <div className="grid grid-cols-2 gap-2">
        <button onClick={saveImage} disabled={busy} data-testid="pass-save-image-btn"
          className="py-3 px-3 rounded-xl bg-amber-600 hover:bg-amber-500 disabled:opacity-50 text-zinc-950 text-sm font-bold flex flex-col items-center gap-1 transition-colors">
          <span className="text-xl">📷</span> Enregistrer dans Photos
        </button>
        {installed ? (
          <div data-testid="pass-installed-badge"
            className="py-3 px-3 rounded-xl bg-emerald-900/40 border border-emerald-700 text-emerald-200 text-sm font-bold flex flex-col items-center gap-1 justify-center">
            <span className="text-xl">✅</span> Installée sur l'accueil
          </div>
        ) : (
          <button onClick={addToHome} data-testid="pass-add-home-btn"
            className="py-3 px-3 rounded-xl bg-zinc-800 hover:bg-zinc-700 border border-zinc-700 text-zinc-100 text-sm font-bold flex flex-col items-center gap-1 transition-colors">
            <span className="text-xl">📲</span> Ajouter à l'écran d'accueil
          </button>
        )}
      </div>
      <button disabled data-testid="pass-wallet-placeholder-btn" title="Bientôt disponible"
        className="mt-2 w-full py-2.5 rounded-xl bg-zinc-900 border border-dashed border-zinc-700 text-zinc-500 text-xs font-semibold cursor-not-allowed">
         Apple Wallet · Google Wallet — bientôt
      </button>
      <p className="mt-2 text-[11px] text-zinc-500 text-center">
        Une fois ajoutée à l'écran d'accueil, la carte s'ouvre plein écran et fonctionne même sans réseau au dojo.
      </p>
      {guide && <InstallGuide onClose={() => setGuide(false)} />}
    </div>
  );
}
